import React, { useEffect, useState } from 'react';

import {
  TrustBasedMessage,
  TrustBasedStringContainer
} from './styledComponent';

interface Props {
  nudges: string[];
  containerCss?: React.CSSProperties;
}

const DynamicTrustBasedMessages: React.FC<Props> = (props: Props) => {
  const [index, setIndex] = useState(0);

  if (!Array.isArray(props.nudges) || props.nudges.length === 0) {
    return null;
  }

  const messages = props.nudges;

  // Reset index when messages array length changes to prevent out-of-bounds access
  useEffect(() => {
    setIndex((current) => current % messages.length);
  }, [messages.length]);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [messages.length]);

  return (
    <TrustBasedStringContainer css={props.containerCss}>
      <TrustBasedMessage
        key={index}
        dangerouslySetInnerHTML={{ __html: messages[index] }}
      />
    </TrustBasedStringContainer>
  );
};

export default DynamicTrustBasedMessages;
